import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Input, ModalFooter, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Btn } from '../../AbstractElements';
import CommonModal from '../../Components/Modals/modal';
import Checkbox from '../../Components/ChackBoxCell/ChackBox';
import { useLocation } from 'react-router';
import { addliveClass,  } from '../../store/liveClassSlice';
import { addenotes, getenotes, ModalToggle } from '../../store/enotesSlice';
import { getenotesSubject } from '../../store/enotesSubjectSlice';

const EnotesTable = () => {
  const storeVar = useSelector(state => state.enote);  
  const subjectVar = useSelector(state => state.enoteSubject);
  const dispatch = useDispatch();
  const location = useLocation();
  const [mainId, setMainId] = useState('');
  const [selectedSubjectId, setSelectedSubjectId] = useState('');
  const [selectedChapters, setSelectedChapters] = useState({});


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setMainId(id);
    dispatch(getenotes(id));
    dispatch(getenotesSubject(10, 0, "active", ""));
  }, []);

  useEffect(() => {
    if (storeVar.enotesData?.enotes) {
      const initialMap = {};
      storeVar.enotesData.enote.forEach(ch => {
        const enoteSubjectId = ch.enoteSubjectId;
        if (!initialMap[enoteSubjectId]) initialMap[enoteSubjectId] = [];
        if (!initialMap[enoteSubjectId].includes(ch._id)) {
          initialMap[enoteSubjectId].push(ch._id);
        }
      });
      console.log(initialMap);
      
      setSelectedChapters(initialMap);
    }
  }, [storeVar.enotesData]);

  const handleSubjectChange = (e) => {
    setSelectedSubjectId(e.target.value);
  };

  const handleChapterToggle = (chapterId) => {
    setSelectedChapters((prev) => {
      const current = prev[selectedSubjectId] || [];
      const exists = current.includes(chapterId);
      const updated = exists
        ? current.filter(id => id !== chapterId)
        : [...current, chapterId];
      return { ...prev, [selectedSubjectId]: updated };
    });
  };

  const getSubjectChapters = () => {
    return subjectVar.enotesSubjectData.find(sub => sub._id === selectedSubjectId)?.enoteChapters || [];
  };

  const AddToggleModal = () => {
    dispatch(ModalToggle());
  };


  const handleSaveSelectedChapters = () => {
    const allChapterIds = Object.values(selectedChapters).flat();
    dispatch(addenotes({ testSeriesId: mainId, subjectIds: allChapterIds },mainId))


  };


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="10"></Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                  Update Enotes
                </Btn>
              </Col>
            </Row>
          </CardHeader>
          <div className='table-responsive'>
            <Table hover className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th>Sl.No</th>
                  <th>Subject</th>
                  <th>Chapters</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.enotesData.enotes?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>
                      {item.enoteChapters?.map((ch, i) => (
                        <p key={i}>{ch.title}</p>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </Col>

      <CommonModal isOpen={storeVar.isOpenModal} title="Add Classes" toggler={AddToggleModal}>
        <Form>
          <FormGroup>
            <Input
              className="form-control btn-square"
              type="select"
              value={selectedSubjectId}
              onChange={handleSubjectChange}
            >
              <option value="">Select Subject</option>
              {subjectVar.enotesSubjectData.map((item, index) => (
                <option key={index} value={item._id}>{item.title}</option>
              ))}
            </Input>
          </FormGroup>

          {selectedSubjectId && getSubjectChapters().map((chapter) => (
            <Checkbox
              key={chapter._id}
              item={chapter}
              checked={selectedChapters[selectedSubjectId]?.includes(chapter._id)}
              onToggle={handleChapterToggle}
            />
          ))}
        </Form>

        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: AddToggleModal }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: handleSaveSelectedChapters }}>
            Save Changes
          </Btn>

        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default EnotesTable;

